import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import SignupComponent from "./signup.component.jsx";
import { useAppDispatch } from "../../hooks/reduxHooks.js";
import { registerTenantsApi } from "../../services/register.service.js";
import { getTenantInfoApi } from "../../services/tenant.service.js";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const SignupContainer = () => {
  const [submitting, setSubmitting] = useState(false);
  const [checkingTenant, setCheckingTenant] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleCheckTenant = (slug) => {
    return new Promise((resolve, reject) => {
      setCheckingTenant(true);
      dispatch(
        getTenantInfoApi({
          params: { slug },
          finalCallback: () => setCheckingTenant(false),
          successCallback: (data) => {
            reject(new Error('tenant_exists'));
          },
          failureCallback: (error) => {
            if (error?.response?.status === 404) {
              resolve();
            } else {
              reject(new Error('check_failed'));
            }
          },
        })
      );
    });
  };

  const handleSignup = (values) => {
    console.log("Signup values -> ", values);
    setSubmitting(true);

    const payload = {
      org_email: values.org_email,
      org_name: values.org_name,
      org_acronym: values.org_acronym,
      username: values.username,
      password: values.password,
      recaptcha_token: values.recaptcha_token,
    };

    dispatch(
      registerTenantsApi({
        params: payload,
        finalCallback: () => {
          setSubmitting(false);
        },
        successCallback: (res) => {
          message.success("Registration successful! Please verify your email.");
          const verificationToken = res?.verify_token || res?.verify_link;
          // Save signup data to session storage for potential correction
          sessionStorage.setItem('signupData', JSON.stringify(payload));
          navigate(`/verify?token=${verificationToken}`);
        },
        failureCallback: (error) => {
          console.error("Registration failed:", error);
          message.error(
            error?.response?.data?.message || error?.response?.data?.detail || "Registration failed. Please try again."
          );
        },
      })
    );
  };

  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.VITE_RECAPTCHA_SITE_KEY}>
      <SignupComponent
        handleSignup={handleSignup}
        submitting={submitting}
        handleCheckTenant={handleCheckTenant}
        checkingTenant={checkingTenant}
      />
    </GoogleReCaptchaProvider>
  );
};

export default SignupContainer;
